import firedux from '../firedux'

import {
  EXPERT_SESSION_REQUESTS_ENDPOINT,
  SESSION_REQUEST_STATUSES
} from '../../config/constants'

import createExpertSession from './create_session_with_expert'

export default (expertUid, userUid) => {
  const ENDPOINT = `${EXPERT_SESSION_REQUESTS_ENDPOINT}/${expertUid}/${userUid}`

  return firedux.ref.child(ENDPOINT).update({status: SESSION_REQUEST_STATUSES.DISMISSED})
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/dismiss_session_request.js
 **/